import { API_URL } from "config";
import Http from "util/https";
import { AmountHiddenSymbol, SearchApiParams, StockList, StockResponse, StockResponseApi, StockSetResponse } from "../types/index";
import { convertUTCToDateTimeMinutes, nullToBlank, nullToZero } from "../utils/common";
import { stockbaseApiResponse } from "./apiConstants";

const splitSetStr = '+';

/**
 * 商品管理部用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns StockList
 */
export default async function stockListApi(params: SearchApiParams) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/select/product`;
  const res = await http.post<StockResponseApi>(url, params);

  // const res: {data: StockResponseApi} = {data: stockbaseApiResponse};
  // await new Promise((resolve) => {setTimeout(resolve, 1500)});

  const stockList: StockList = {
    total: res.data.total,
    stocks: res.data.stocks.map((st, i) => {
      if (st.item_code.length === 6) {
        const s = st as StockResponse; // 単品
        const notNullVendorQuantity = nullToBlank(s.vendor_quantity, '-') as number | AmountHiddenSymbol;
        // 単品
        return {
          id: `${i + (params.offset ?? 0)}`,
          JANCd: s.jan_cd,
          productNumber: s.item_num,
          productName: s.item_name ?? '',
          brand: s.brand_name ?? '',
          productCd: s.item_code,
          size: s.size ?? '',
          classification: s.class_name,
          storehouses: [{
            id: '0001',
            name: '明和町',
            region: '群馬',
            amount: nullToZero(s.quantity_meiwa),
          },{
            id: "0002",
            name: "加西",
            region: "兵庫",
            amount: nullToZero(s.quantity_kasai)
          },
          {
            id: "0003",
            name: "伊藤忠",
            region: "大阪",
            amount: nullToZero(s.quantity_itochu)
          },
          {
            id: "0004",
            name: "昭和製氷",
            region: "静岡",
            amount: nullToZero(s.quantity_shouwa)
          },
          {
            id: "0005",
            name: "東北",
            region: "青森",
            amount: nullToZero(s.quantity_tohoku)
          },
          {
            id: "0006",
            name: "関東",
            region: "群馬",
            amount: nullToZero(s.quantity_kanto)
          },
          {
            id: "0007",
            name: "西日本",
            region: "大阪",
            amount: nullToZero(s.quantity_nishinihon)
          }],
          supplierName: s.vendor_name,
          supplierAmount: Number.isNaN(Number(notNullVendorQuantity)) ? notNullVendorQuantity : Number(notNullVendorQuantity),
          supplierDate: s.vendor_updated_at,
          isDiscontinued: !!s.discontinued_flag
        }
      }
      // セット
      const s = st as StockSetResponse; // セット
      return {
        id: `${i + (params.offset ?? 0)}`,
        JANCd: s.jan_cd,
        productNumber: s.item_num,
        productName: s.item_name ?? '',
        productSetCd: s.item_code,
        classification: "タイヤ・ホイール", // s.class_name,
        stockSingleList: [{
          // タイヤ
          productCd: s.item_code.slice(0, 6),
          productName: s.item_name ? s.item_name.split(splitSetStr)[0] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[0] : '',
          size: s.size ? s.size.split(splitSetStr)[0] : '',
          quantity: 1
        }, {
          // ホイール
          productCd: s.item_code.slice(6, 12),
          productName: s.item_name ? s.item_name.split(splitSetStr)[1] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[1] : '',
          size: s.size ? s.size.split(splitSetStr)[1] : '',
          quantity: 1
        }],
        storehouses: [{
          id: '0001',
          name: '明和町',
          region: '群馬',
          amount: (() => {
            const index = s.depot_stocks.findIndex(ds => ds.location_name === "明和倉庫")
            return nullToZero(index > 0 ? s.depot_stocks[index].quantity : s.depot_quantity);
          })(), // セット品の在庫は明和町の倉庫に集約されるため、明和町の在庫をセット品の在庫として返す
        },{ // 明和町以下はセット品では在庫がないため、必ず0が入る
          id: "0002",
          name: "加西",
          region: "兵庫",
          amount: 0
        },
        {
          id: "0003",
          name: "伊藤忠",
          region: "大阪",
          amount: 0
        },
        {
          id: "0004",
          name: "昭和製氷",
          region: "静岡",
          amount: 0
        },
        {
          id: "0005",
          name: "東北",
          region: "青森",
          amount: 0
        },
        {
          id: "0006",
          name: "関東",
          region: "群馬",
          amount: 0
        },
        {
          id: "0007",
          name: "西日本",
          region: "大阪",
          amount: 0
        }],
        isDiscontinued: !!s.discontinued_flag
      }
    }),
    storehouseUpdated: convertUTCToDateTimeMinutes(res.data.depot_updated)
  }

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res);
  // return res.data;
  return stockList;
}